var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2415_6691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 9.9987C2.71224 9.9987 2.40161 9.9987 2.15658 9.8972C1.82988 9.76188 1.57032 9.50231 1.43499 9.17561C1.3335 8.93058 1.3335 8.61995 1.3335 7.9987V3.46536C1.3335 2.71863 1.3335 2.34526 1.47882 2.06004C1.60665 1.80916 1.81063 1.60519 2.06151 1.47736C2.34672 1.33203 2.72009 1.33203 3.46683 1.33203H8.00016C8.62142 1.33203 8.93205 1.33203 9.17707 1.43353C9.50378 1.56885 9.76334 1.82842 9.89867 2.15512C10.0002 2.40015 10.0002 2.71078 10.0002 3.33203M8.1335 14.6654H12.5335C13.2802 14.6654 13.6536 14.6654 13.9388 14.52C14.1897 14.3922 14.3937 14.1882 14.5215 13.9374C14.6668 13.6521 14.6668 13.2788 14.6668 12.532V8.13203C14.6668 7.38529 14.6668 7.01193 14.5215 6.72671C14.3937 6.47583 14.1897 6.27185 13.9388 6.14402C13.6536 5.9987 13.2802 5.9987 12.5335 5.9987H8.1335C7.38676 5.9987 7.01339 5.9987 6.72818 6.14402C6.47729 6.27185 6.27332 6.47583 6.14549 6.72671C6.00016 7.01193 6.00016 7.38529 6.00016 8.13203V12.532C6.00016 13.2788 6.00016 13.6521 6.14549 13.9374C6.27332 14.1882 6.47729 14.3922 6.72818 14.52C7.01339 14.6654 7.38676 14.6654 8.1335 14.6654Z",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2415_6691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.9a6a08f6f6310b888fe27cd38498316c.svg";
export { ForwardRef as ReactComponent };